import round from 'lodash/round';

export const ConvertDDToDMS = (D: number, isLat: boolean) => {
  // eslint-disable-next-line no-nested-ternary
  const dir = isLat ? (D < 0 ? 'S' : 'N') : D < 0 ? 'W' : 'E';

  const dec = Math.abs(D);
  const degrees = Math.floor(dec);
  const minfloat = (dec - degrees) * 60;
  const minutes = Math.floor(minfloat);
  const minSeconds = (minfloat - minutes) * 60;
  const seconds = round(minSeconds, 8);

  return [degrees, minutes, seconds, dir];
};
